import { useReduxState } from 'hooks';

interface Props {
  label: string;
  value: string;
}

const UserValue = ({ label, value }: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="user-value">
      <div className="label">{label}</div>
      <div className="value">{value}</div>

      <style jsx>{`
        .user-value {
          line-height: 1.2;
        }
        .label {
          color: ${theme.textColorLighter};
          font-size: 1.3rem;
          font-weight: 600;
        }
        .value {
          color: ${theme.textColor};
          font-size: 1.4rem;
          font-weight: 600;
        }
      `}</style>
    </div>
  );
};

export default UserValue;
